import * as React from "react"
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
    User,
    MoreVertical,
    ChevronDown,
    LogOut
} from "lucide-react";
import { useAuth }  from "@/hooks/use-auth";

const Navbar = React.forwardRef(({ hideNavigation = false, ...props }, ref) => {
const authStore = useAuth();
const navigate = useNavigate();

const handleLogout = () => {
    authStore.logout();
    navigate('/login');
}

const scrollIntoElement = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
    }
}

const handleSmoothScroll = (event) => {
    event.preventDefault();
    const href = event.currentTarget.getAttribute('href');
    const targetId = href.split('/#')[1];
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' });
    }else{
        navigate(href);
        setTimeout(() => {
            scrollIntoElement(targetId);
        }, 1000);
    }
};

const isActive = (path) => {
    return window.location.pathname === path || window.location.pathname === path + '/' || window.location.hash === '#' + path;
}

return (
    <header className="border-b border-zinc-800 bg-[#09090B]/50 backdrop-blur-md sticky top-0 z-40">
    <div className="container mx-auto px-4 py-4 flex items-center justify-between my-auto min-h-[80px]">
        <nav className="flex items-center gap-8">
        <Link to="/" className="flex items-center gap-2">
        <img className="h-8" src="/assets/logo_garudaqr.png" />
        </Link>
        { !hideNavigation && <>
            {!authStore.isAuthenticated && <Link
                to="/#pricing"
                className="text-white font-semibold transition-colors flex items-center gap-1"
                data-testid="nav-pricing"
                onClick={handleSmoothScroll}
                >
                <span className={`hidden sm:inline hover:text-primary-500/80 ${isActive('pricing') && 'text-primary-500'} `}>Daftar Harga</span>
            </Link>}
            {authStore.isAuthenticated && <Link
                to="/dashboard"
                className="text-white font-semibold transition-colors flex items-center gap-1"
                data-testid="nav-dashboard"
                >
                <span className={`hidden sm:inline hover:text-primary-500/80 ${isActive('/dashboard') && 'text-primary-500'} `}>Dashboard</span>
            </Link>}
            <Link
                to="/docs"
                className="text-white font-semibold transition-colors flex items-center gap-1"
                data-testid="nav-docs"
                >
                <span className={`hidden sm:inline hover:text-primary-500/80 ${isActive('/docs') && 'text-primary-500'} `}>API Docs</span>
            </Link>
        </>}
        </nav>
        { !hideNavigation && !authStore.isAuthenticated && <nav className="flex items-center gap-4" >
        <Link
            to="/register"
            className="text-white font-semibold transition-colors flex items-center gap-1"
            data-testid="nav-login"
        >
            <span className="hidden sm:inline">Daftar</span>
        </Link>
        <Link
            to="/dashboard"
        >
            <Button size="lg">
                Masuk
            </Button>
        </Link>
        </nav>}
        { !hideNavigation && authStore.isAuthenticated && <nav className="flex items-center gap-4">
            <DropdownMenu>
                <DropdownMenuTrigger asChild>
                <div className="text-white font-semibold bg-primary-500/40 rounded-[0.5rem] cursor-pointer">
                    <div className="flex items-center justify-between px-2 py-1 h-10 w-16">
                        <i className="garuda-person"/>
                        <ChevronDown className="w-full h-4" />
                    </div>
                </div>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="bg-dark-foreground border-zinc-800">
                {/* <DropdownMenuItem className="text-white font-semibold">
                    <Link to="/dashboard">
                        Dashboard
                    </Link>
                </DropdownMenuItem> */}
                <DropdownMenuItem className="text-white font-semibold cursor-pointer" onClick={() => handleLogout()}>
                    Logout
                </DropdownMenuItem>
                </DropdownMenuContent>
            </DropdownMenu>
        </nav> }
    </div>
    </header>
);
})

export default Navbar